import React from 'react';

import {Box, Flex, Icon, Text} from '@spothero/ui';
import IconBuildings from '@spothero/icons/buildings';

const bannerContainerStyles = {
    position: 'absolute',
    right: 0,
    top: 0,
    borderBottomLeftRadius: 10,
    backgroundColor: 'green.default',
    paddingY: 2,
    paddingX: 2,
};

const bannerTextStyles = {
    variant: 'caption',
    color: 'white',
};

const PortfolioViewBanner = () => {
    return (
        <Box data-testid="PortfolioViewBanner" {...bannerContainerStyles}>
            <Flex>
                <Icon
                    as={IconBuildings}
                    boxSize={4}
                    color="white"
                    marginRight={1}
                />
                <Text {...bannerTextStyles} fontWeight="semibold">
                    Portfolio View
                </Text>
            </Flex>
        </Box>
    );
};

export default PortfolioViewBanner;
